module.exports = __webpack_public_path__ + "img/Skirt-Back-B2-Da-Gd-Ha-Ia.2ed2b5b0.png";